import { api } from '@whitesharx/starfall-frontend-core';

export type AnalyzLimitRequestRespones = {
  date: string | null;
  adDate: string | null;
};

export const getAnalysisLimitRequest = () => api.v1.get('analysis') as Promise<AnalyzLimitRequestRespones>;
